import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { SKIP_LOADING } from '@core/http/http-context.tokens';
import { LoadingService } from '@core/services/loading.service';

/** Increments global loading count around each HTTP call (pattern from v16 `LoadingService` + interceptor idea). */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const requestId = loading.beginRequest();
  return next(req).pipe(finalize(() => loading.endRequest(requestId)));
};
